module.exports = __webpack_public_path__ + "static/media/angle-arrow-up-white.e60b3e19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-up-white.svg
// module id = 556
// module chunks = 0